const STEPS = [
  {
    number: "1",
    title: "Set up your school",
    description:
      "Configure your grade levels, tuition rates, fee schedules, and payment calendar. We'll help you get everything dialed in.",
  },
  {
    number: "2",
    title: "Invite families",
    description:
      "Parents get a secure invite link to create their account, register students, and add a payment method.",
  },
  {
    number: "3",
    title: "Payments run on autopilot",
    description:
      "Tuition and fees bill automatically on your schedule. Parents get receipts, your office gets a real-time ledger.",
  },
];

export default function Metrics() {
  return (
    <section className="section" id="how-it-works">
      <div className="container">
        <header className="section-header">
          <p className="section-eyebrow">How it works</p>
          <h2 className="section-title">Up and running in days, not months.</h2>
          <p className="section-lede">
            No complex integrations or IT projects. If your school can use email,
            you can use Easy School Payments.
          </p>
        </header>
        <div className="steps-grid">
          {STEPS.map((s) => (
            <div key={s.number} className="step">
              <div className="step-number">{s.number}</div>
              <h3>{s.title}</h3>
              <p>{s.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
